import { convertPdfToImages } from "./ConvertPdfToImg";

export const handlePrintData = async (
  htmlContent,
  fileName = "document",
  pdfBase64
) => {
  let pdfImages = [];
  if (pdfBase64) {
    pdfImages = await convertPdfToImages(pdfBase64);
  }

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow.document;
  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <script src="https://cdn.tailwindcss.com"></script>
        <title>${fileName}</title>
        <style>
          *, *::before, *::after {
            box-sizing: border-box;
          }
          html, body {
            width: 100%;
            max-width: 100%;
            margin: 0;
            padding: 8px;
            font-family: Arial, sans-serif;
            font-size: 10px;
            color: #000;
            overflow-x: hidden;
          }
          img {
            max-width: 100%;
            height: auto;
            margin: 4px 0;
          }
          table {
            width: 100% !important;
            max-width: 100% !important;
            border-collapse: collapse;
            table-layout: fixed;
            word-break: break-word;
            overflow-wrap: break-word;
          }
          td, th {
            word-break: break-word;
            overflow-wrap: break-word;
          }
          /* Prevent any element from exceeding page width */
          div, section, article, p, span {
            max-width: 100%;
          }
          @media print {
            @page {
              size: A4 portrait;
              margin: 6mm 8mm 8mm 8mm;
            }
            html, body {
              width: 100%;
              max-width: 100%;
              margin: 0;
              padding: 0;
              font-size: 10px;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            thead {
              display: table-header-group !important;
            }
            tfoot {
              display: table-footer-group !important;
            }
            .report-print-table {
              width: 100% !important;
              max-width: 100% !important;
              border-collapse: collapse !important;
              border: none !important;
              margin: 0 !important;
              padding: 0 !important;
              table-layout: auto !important;
            }
            .report-print-table > thead > tr > td,
            .report-print-table > tbody > tr > td {
              padding: 0 !important;
              border: none !important;
              background: transparent !important;
            }
            table:not(.report-print-table) {
              page-break-inside: auto;
              width: 100% !important;
              max-width: 100% !important;
              table-layout: fixed;
            }
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            .emr-section {
              break-inside: avoid !important;
              page-break-inside: avoid !important;
            }
            /* Tailwind grid/flex helpers for print */
            .grid { display: grid; }
            .grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
            .grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
            .grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
            .grid-cols-7 { grid-template-columns: repeat(7, minmax(0, 1fr)); }
            .flex { display: flex; }
            .flex-1 { flex: 1 1 0%; min-width: 0; }
            .gap-1 { gap: 0.25rem; }
            .gap-2 { gap: 0.5rem; }
            .no-print { display: none !important; }
            .emr-print-footer {
              width: 100% !important;
              margin: 16px auto 0 !important;
              background: white !important;
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
          }
        </style>
      </head>
      <body>
        ${htmlContent}
         ${
           pdfImages?.length > 0
             ? pdfImages?.map((src) => `<img src="${src}" />`).join("")
             : ""
         }
      </body>
    </html>
  `);
  doc.close();

  iframe.onload = () => {
    const originalTitle = document.title;
    document.title = fileName;
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => {
      document.title = originalTitle;
      document.body.removeChild(iframe);
    }, 1000);
  };
};

export const openImage = (base64Data) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: "image/png" });
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
};
